import { DOCUMENT_FORMATS } from './documentFormats.js';

/**
 * Pictogramme d'un document : page à coin plié, aux couleurs du format (tokens
 * --ds-doc-<format>-*), avec le libellé court du format (pas seulement la couleur).
 * Format inconnu (skeleton avant l'annonce du format) : page neutre.
 */
export function DocumentGlyph({ format = null, size = 'md' }) {
  const info = DOCUMENT_FORMATS[format] ?? null;
  return (
    <span className={`doc-glyph doc-glyph--${info ? info.key : 'unknown'} doc-glyph--${size}`} aria-hidden="true">
      <svg className="doc-glyph__page" viewBox="0 0 40 48">
        <path className="doc-glyph__sheet" d="M6 2h20l10 10v32a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" />
        <path className="doc-glyph__fold" d="M26 2v8a2 2 0 0 0 2 2h8" />
        <path className="doc-glyph__lines" d="M10 22h20M10 28h20M10 34h13" />
      </svg>
      <span className="doc-glyph__ext">{info ? info.ext.toUpperCase() : '···'}</span>
    </span>
  );
}
